import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { Bar } from "react-chartjs-2";
import PropTypes from "prop-types";
import moment from "moment";

// const labels = [
//   "Tháng 1",
//   "Tháng 2",
//   "Tháng 3",
//   "Tháng 4",
//   "Tháng 5",
//   "Tháng 6",
//   "Tháng 7",
//   "Tháng 8",
//   "Tháng 9",
//   "Tháng 10",
//   "Tháng 11",
//   "Tháng 12",
// ];

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Chart.js Bar Chart",
    },
  },
};
export const ChartKpi = React.forwardRef((props, ref) => {
  const { colors, showChart } = props;
  const [selectionState, setSelectionState] = useState([]);
  const [date, setDate] = useState([]);

  useEffect(() => {
    const test = selectionState.map(item =>
      moment(item.to.iso).format("MM/YYYY")
    );

    const uniqueArray = test.filter(function (item, pos) {
      return test.indexOf(item) == pos;
    });
    setDate(uniqueArray);
  }, [selectionState]);

  const data = {
    labels: date.sort(),
    datasets: selectionState.map((item, index) => {
      return {
        label: item?.kpi?.name || item?.name || item?.fullName,
        data:
          showChart === "saleTotal"
            ? selectionState.map(item => item?.saleTotal)
            : showChart === "bonus"
            ? selectionState.map(item => item?.bonus)
            : selectionState.map(item => item?.commision),
        backgroundColor: colors[index],
      };
    }),
  };

  useImperativeHandle(ref, () => ({
    reRender: data => {
      setSelectionState(data);
    },
  }));

  return <Bar options={options} data={data} />;
});

ChartKpi.propTypes = {
  colors: PropTypes.array,
  kpiGroup: PropTypes.array,
  dataTableChart: PropTypes.any,
  showChart: PropTypes.string,
};
